import { types } from "../types/types";

const initialState = {
  user: null,
  loggedIn: false,
  idToken: "",
  isAlmighty: false,
  isAdmin: false,
  isModerator: false,
  isLoadingAuth: true,
  userGetToken: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.login:
      return {
        ...state,
        user: action.payload.user,
        loggedIn: action.payload.loggedIn,
        idToken: action.payload.idToken,
        isAlmighty: action.payload.isAlmighty || false,
        isAdmin: action.payload.isAdmin || false,
        isModerator: action.payload.isModerator || false,
        isLoadingAuth: action.payload.isLoadingAuth || false,
        //isLoadingAuth: true,
        userGetToken: action.payload.userGetToken,
      };
    case types.isLoadingAuth:
      return {
        ...state,
        isLoadingAuth: action.payload.isLoadingAuth,
      };

    case types.loginStart:
      return {
        ...state,
        isLoadingAuth: action.payload,
      };

    case types.logout:
      return initialState;

    case types.logoutSuccess:
      return {
        ...initialState,
        isLoadingAuth: false,
      };

    case types.logoutError:
      return {
        ...state,
        error: action.payload,
      };

    case types.loginFailure:
      return {
        ...state,
        error: action.payload,
        isLoadingAuth: false,
      };

    default:
      return state;
  }
};
